import { ApiService } from 'app/auth/helpers/apiservice';
import { FormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSpinnerComponent } from 'app/main/pages/modal-spinner/modal-spinner.component';
import { timerRedo } from 'app/utils/timer';
import { ToastService } from 'app/service/toast.service';
interface notification {
  messages: [];
  systemMessages: [];
  system: Boolean;
}
@Component({
  selector: 'app-navbar-comm',
  templateUrl: './navbar-comm.component.html',
  styleUrls: ['./navbar-comm.component.scss']
})
export class NavbarCommComponent implements OnInit {
  msg: string;
  public ctrl = new FormControl(null, Validators.required);
  @ViewChild(NgbDropdown) drop:NgbDropdown;
  // Public
  public notifications: notification;

  /**
   *
   * @param {NotificationsService} _notificationsService
   */
  constructor(private ApiSrv: ApiService, private toastr: ToastService, private modal: NgbModal) {}

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    
  }

  com() {
    if (!this.ctrl.value || !this.msg) {
      return
    }
    const params = {
      message: this.msg,
      nbEtoiles: this.ctrl.value
    }

    const data = {
      schema_webservice: '/reclamations/avis',
      params
    };

     this.ApiSrv.api(data).subscribe((res) => {
      if (res.code === '00') {
        this.toastr.success(res.message);
        this.drop.close();
        this.ctrl.reset();
        this.msg = null;
      } else if (res.code === '01') {
        this.toastr.error(res.message);
      } else if (res.code === '08') {
        const modalRef = this.modal.open(ModalSpinnerComponent, { centered: true,backdrop: "static", windowClass:'custommodal' });
        setTimeout(() => {
          modalRef.dismiss();
          this.com();
        }, timerRedo);
      }
    });
  }

}
